var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('v-card',{staticClass:"pa-6 mx-6 my-6 elevation-0",attrs:{"outlined":""}},[_c('AttendanceFilter',{ref:"attendance-filter",on:{"search":_vm.handleSearch}})],1),_c('v-card',{staticClass:"mx-6 mb-6 elevation-0",attrs:{"outlined":""}},[_c('AttendanceDataTable',{ref:"table"})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }